import { path } from '@bo-client/shared/constants/path';
import { AreaTypeEnum } from '@bo-client/activation-management/shared/models/commissioningModel';
import { UserRole } from '@bo-client/shared/models/user-roles.enum';
import { ObjectPath } from '@bo-client/shared/types/ObjectPath.type';
import { NBPConfig } from '@bo-client/shared/config.model';

export interface SideMenuNode {
  label: string;
  isTitle?: boolean;
  isActive?: boolean;
  icon?: string;
  link?: string;
  enabled?: boolean;
  permission?: string;
  feature?: string;
  roles: Array<UserRole>;
  areaTypes?: AreaTypeEnum[];
  uiAdaption?: string;
  tenantConfig?: ObjectPath<NBPConfig>;
  children?: SideMenuNode[];
}

export const MainTreeMenuData: SideMenuNode[] = [
  {
    label: 'Apps',
    isTitle: true,
    roles: ['ROLE_ADMIN', 'ROLE_SUPERADMIN', 'ROLE_ADMIN_INSTALLATEUR']
  },
  {
    enabled: true,
    label: 'Home',
    icon: 'desktop_windows',
    link: path.tmPath + path.tmDesktop,
    permission: 'VIEW_HOME',
    roles: ['ROLE_ADMIN_INSTALLATEUR']
  },
  {
    enabled: true,
    label: 'Accountverwaltung',
    icon: 'business',
    link: path.tmPath + path.tmCompanyAccount,
    permission: 'VIEW_INSTALLER_ACCOUNT',
    roles: ['ROLE_ADMIN_INSTALLATEUR']
  },
  // display twice Users/Installer-Pass  option for ROLE_INSTALLATEUR
  {
    enabled: true,
    label: 'Benutzer / Ausweise',
    icon: 'supervised_user_circle',
    link: path.tmPath + path.tmUserList,
    permission: 'VIEW_INSTALLER_ACCOUNT',
    roles: ['ROLE_ADMIN_INSTALLATEUR', 'ROLE_INSTALLATEUR']
  },
  {
    enabled: true,
    label: 'Hausanschlüsse - Beta',
    icon: 'cottage',
    link: path.hapPrefix + '/' + path.hapOrdersV2,
    roles: ['ROLE_KEYUSER_ORDERREQUESTS', 'ROLE_SUPERADMIN']
  },
  {
    enabled: true,
    label: 'Hausanschlüsse',
    icon: 'cottage',
    link: path.hapPrefix + '/' + path.hapOrders,
    permission: 'VIEW_HA_LIST',
    roles: ['ROLE_EDITOR', 'ROLE_VIEWER_ORDERREQUESTS', 'ROLE_ADMIN', 'ROLE_SUPERADMIN']
  },
  {
    enabled: true,
    label: 'Anschluss-Änderungen',
    icon: 'electrical_services',
    tenantConfig: 'connectionChangeRequest.isActive',
    link: path.hapPrefix + '/' + path.hapConnectionChange + path.list,
    roles: [
      'ROLE_EDITOR_CONNECTION_CHANGE_REQUESTS',
      'ROLE_KEYUSER_CONNECTION_CHANGE_REQUESTS',
      'ROLE_SUPERADMIN'
    ]
  },
  {
    enabled: true,
    label: 'Erweiterungsgebiete',
    icon: 'add_location_alt',
    link: path.hapPrefix + '/' + path.hapDevelopmentAreas,
    permission: 'VIEW_HA_DEVELOPMENT_AREAS',
    roles: ['ROLE_ADMIN', 'ROLE_SUPERADMIN']
  },
  {
    enabled: true,
    label: 'Geschäftspartner',
    icon: 'group',
    link: path.hapPrefix + '/' + path.hapBusinessPartner,
    permission: 'VIEW_BUSINESSPARTNERS',
    roles: ['ROLE_EDITOR', 'ROLE_EDITOR_BASE', 'ROLE_ADMIN', 'ROLE_SUPERADMIN']
  },
  {
    enabled: true,
    label: 'Ausweise - Beta',
    icon: 'badge',
    link: path.tmPrefix + '/' + path.tmInstallerPassListAdmin + '-next' + path.list,
    permission: 'VIEW_INSTALLER_PASS_LIST_ADMIN_V2',
    roles: ['ROLE_SUPERADMIN']
  },
  {
    enabled: true,
    label: 'Ausweise',
    icon: 'badge',
    link: path.tmPrefix + '/' + path.tmInstallerPassListAdmin,
    permission: 'VIEW_INSTALLER_PASS_LIST',
    roles: ['ROLE_ADMIN', 'ROLE_SUPERADMIN']
  },
  {
    enabled: true,
    label: 'Meine Inbetriebnahmen',
    icon: 'build',
    link: path.cmPrefix + '/' + path.cmCommissioningManagement,
    permission: 'VIEW_COMMISSIONING_MY',
    roles: ['ROLE_INSTALLATEUR']
  },
  {
    enabled: true,
    label: 'Inbetriebnahmen - Beta',
    icon: 'build',
    link: path.cmPrefix + '/' + 'commissioning-request-next' + path.list,
    permission: 'VIEW_COMMISSIONING_REQUEST_LIST_ADMIN_V2',
    roles: ['ROLE_SUPERADMIN', 'ROLE_EDITOR_COMMISSIONING']
  },
  {
    enabled: true,
    label: 'Inbetriebnahmen',
    icon: 'build',
    link: path.cmPrefix + '/' + path.cmCommissioningManagement,
    permission: 'VIEW_COMMISSIONING_LIST_ADMIN',
    roles: ['ROLE_EDITOR_COMMISSIONING']
  },
  {
    enabled: true,
    label: 'Netzanmeldungen - Beta',
    icon: 'bolt',
    link: path.cmPrefix + '/' + path.cmGridRegistrationNext + path.list,
    // todo review permissions
    permission: 'VIEW_GRID_REGISTRATION_LIST_ADMIN_V2',
    roles: ['ROLE_SUPERADMIN'],
    areaTypes: [AreaTypeEnum.POWER]
  },
  {
    enabled: true,
    label: 'Netzanmeldungen',
    icon: 'bolt',
    link: path.cmPrefix + '/' + path.cmGridRegistration + path.list,
    // todo review permissions
    permission: 'VIEW_GRID_REGISTRATIONS_MY',
    roles: ['ROLE_INSTALLATEUR'],
    areaTypes: [AreaTypeEnum.POWER],
    uiAdaption: 'feature_gridRegistration'
  },
  {
    enabled: true,
    label: 'Netzanmeldungen',
    icon: 'bolt',
    link: path.cmPrefix + '/' + path.cmGridRegistration + path.list,
    permission: 'VIEW_GRID_REGISTRATION_LIST_ADMIN',
    roles: ['ROLE_SUPERADMIN'],
    areaTypes: [AreaTypeEnum.POWER]
  },
  {
    enabled: true,
    label: 'Einspeiserverträge - Beta',
    icon: 'sticky_note_2',
    link: path.cmPrefix + '/' + path.cmFeederContractV2 + path.list,
    permission: 'VIEW_FEEDER_CONTRACT_LIST_ADMIN_V2',
    roles: ['ROLE_SUPERADMIN'],
    feature: 'FEEDER_CONTRACT',
    areaTypes: [AreaTypeEnum.POWER]
  },
  {
    enabled: true,
    label: 'Einspeiserverträge',
    icon: 'sticky_note_2',
    link: path.cmPrefix + '/' + path.cmFeederContract + path.list,
    roles: [
      'ROLE_VIEWER_FEEDERCONTRACTS',
      'ROLE_KEYUSER_FEEDERCONTRACTS',
      'ROLE_EDITOR_FEEDERCONTRACTS',
      'ROLE_SUPERADMIN'
    ],
    feature: 'FEEDER_CONTRACT',
    areaTypes: [AreaTypeEnum.POWER]
  },
  {
    label: 'Konfiguration',
    isTitle: true,
    roles: ['ROLE_ADMIN', 'ROLE_SUPERADMIN']
  },
  {
    enabled: true,
    label: 'Standorte',
    icon: 'location_on',
    link: path.hapPrefix + '/' + path.hapCompanyLocations,
    permission: 'VIEW_COMPANY_LOCATIONS',
    roles: ['ROLE_ADMIN', 'ROLE_SUPERADMIN']
  },
  {
    enabled: true,
    isActive: true,
    label: 'Vergütungskategorie',
    icon: 'euro',
    link: path.cmPrefix + '/' + path.cmCompCat + path.list,
    permission: 'CCATEGORIES_UPDATE',
    roles: [],
    areaTypes: [AreaTypeEnum.POWER]
  },
  {
    enabled: true,
    label: 'UI-Anpassungen verwalten',
    icon: 'text_fields',
    link: path.hapTenantPrefix + '/' + path.uiAdaptionsManagement + path.list,
    permission: 'VIEW_TENANTS',
    roles: [
      'ROLE_ADMIN',
      'ROLE_SUPERADMIN',
      'ROLE_KEYUSER_COMMISSIONING',
      'ROLE_KEYUSER_FEEDERCONTRACTS',
      'ROLE_KEYUSER_GRIDREGISTRATION',
      'ROLE_KEYUSER_ORDERREQUESTS',
      'ROLE_KEYUSER_INSTALLERPASSES'
    ]
  },
  {
    enabled: true,
    label: 'Wertelisten pflegen',
    icon: 'format_list_numbered',
    link: path.hapTenantPrefix + '/' + path.codeListValues,
    permission: 'VIEW_CODELISTS',
    roles: ['ROLE_SUPERADMIN']
  },
  {
    enabled: true,
    label: 'Installateur-Neuigkeiten verwalten',
    icon: 'edit_notifications',
    link:
      path.hapTenantPrefix +
      '/' +
      path.cssGenericProcessConfiguration +
      '/' +
      'notifications' +
      '/' +
      'config' +
      '/' +
      encodeURIComponent('Installateur-Neuigkeiten'),
    permission: '',
    roles: ['ROLE_SUPERADMIN', 'ROLE_KEYUSER_INSTALLERPASSES']
  },
  {
    enabled: true,
    label: 'Anschlussänderungen verwalten',
    icon: 'electrical_services',
    link:
      path.hapTenantPrefix +
      '/' +
      path.cssGenericProcessConfiguration +
      '/' +
      'connectionChangeRequest' +
      '/' +
      'config' +
      '/' +
      'Anschlussänderungen',
    permission: '',
    roles: ['ROLE_SUPERADMIN', 'ROLE_KEYUSER_CONNECTION_CHANGE_REQUESTS']
  },
  {
    enabled: true,
    label: 'Inbetriebnahme verwalten',
    icon: 'electrical_services',
    link:
      path.hapTenantPrefix +
      '/' +
      path.cssGenericProcessConfiguration +
      '/' +
      'commissioning' +
      '/' +
      'config' +
      '/' +
      'Inbetriebnahme Strom',
    permission: '',
    roles: ['ROLE_SUPERADMIN', 'ROLE_KEYUSER_COMMISSIONING']
  },
  {
    enabled: true,
    label: 'Netzanmeldungen verwalten',
    icon: 'electrical_services',
    link:
      path.hapTenantPrefix +
      '/' +
      path.cssGenericProcessConfiguration +
      '/' +
      'gridRegistration' +
      '/' +
      'config' +
      '/' +
      'Netzanmeldungen',
    permission: '',
    roles: ['ROLE_SUPERADMIN', 'ROLE_KEYUSER_GRIDREGISTRATION']
  },
  {
    enabled: true,
    label: 'Benutzerverwaltung',
    icon: 'manage_accounts',
    link: path.hapPrefix + '/' + path.hapUserList,
    permission: 'VIEW_USERS',
    roles: ['ROLE_USER_ADMIN']
  },
  {
    label: 'Erweiterte Einstellungen',
    isTitle: true,
    roles: ['ROLE_ADMIN', 'ROLE_SUPERADMIN']
  },
  {
    enabled: true,
    label: 'Administration',
    icon: 'settings',
    roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN'],
    children: [
      {
        enabled: true,
        label: 'Benutzer',
        link: path.hapPrefix + '/' + path.hapUserList,
        permission: 'VIEW_USERS',
        roles: ['ROLE_ADMIN', 'ROLE_SUPERADMIN']
      },
      {
        enabled: true,
        label: 'Rollen',
        link: path.hapPrefix + '/' + path.hapRoleList,
        permission: 'VIEW_ROLES',
        roles: ['ROLE_SUPERADMIN']
      },

      {
        enabled: true,
        label: 'Fragen-Konfiguration',
        link: path.tmPrefix + '/' + path.questionList,
        permission: 'VIEW_INSTALLER_QUESTIONS',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        enabled: true,
        label: 'Messkonzept-Konfiguration',
        link: path.cmPrefix + '/' + path.cmAdminMeteringConceptList,
        permission: 'VIEW_INSTALLER_QUESTIONS',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        enabled: true,
        label: 'Prozess-Konfiguration',
        icon: 'rebase',
        link: path.hapTenantPrefix + '/' + path.cssProcessConfiguration,
        permission: 'VIEW_TENANTS',
        roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN']
      },
      {
        enabled: true,
        label: 'Mandanten Liste (Alt)',
        link: path.hapTenantPrefix + '/' + path.hapTenantList,
        permission: 'VIEW_TENANTS',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        enabled: true,
        label: 'Mandanten Einstellungen',
        link: path.hapTenantPrefix + '/' + path.hapTenantConfig,
        permission: 'VIEW_TENANTS',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        enabled: true,
        label: 'UI-Adaptions - Administration',
        icon: 'text_fields',
        link: path.hapTenantPrefix + '/' + path.uiAdaptionsAdmin + path.list,
        permission: 'VIEW_TENANTS',
        roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN']
      },
      {
        enabled: true,
        label: 'UI-Adaptions - Alt',
        link: path.hapTenantPrefix + '/' + path.oldUiAdaptations,
        permission: 'VIEW_TENANTS',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        enabled: true,
        label: 'Verwaltung - Nächste Aktionen',
        link: path.hapTenantPrefix + '/' + path.nextActions,
        roles: ['ROLE_SUPERADMIN']
      },
      {
        enabled: true,
        label: 'Interne Preisfindung',
        link: path.priceCalculationPrefix + '/' + path.priceCalculation,
        permission: 'VIEW_TENANTS',
        roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN']
      },
      {
        enabled: true,
        label: 'Workflow Regel',
        link: path.tmPrefix + '/' + path.tmWorkflowRule,
        roles: ['ROLE_SUPERADMIN', 'ROLE_ADMIN']
      },
      {
        enabled: true,
        label: 'Import Installateur',
        link: path.tmPrefix + '/' + path.tmImportTechnician,
        permission: 'VIEW_IMPORT_INSTALLER',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        enabled: true,
        label: 'Address Sense Service',
        link: path.addressSensePrefix + '/' + path.addressSenseLocalStreets,
        permission: 'VIEW_TENANTS',
        roles: []
      }
    ]
  },

  {
    label: 'CSS Retail',
    isTitle: true,
    permission: 'VIEW_CSS_DEMO',
    roles: []
  },
  // here will follow dummy menu entires
  {
    enabled: true,
    isActive: true,
    label: 'Dashboard',
    icon: 'home',
    link: path.cssPrefix + '/' + path.cssDashboard,
    permission: 'VIEW_CSS_DEMO',
    roles: []
  },
  {
    enabled: true,
    label: 'Prozess-Monitoring',
    icon: 'monitoring',
    link: path.cssPrefix + '/' + path.cssTransactionMonitor,
    permission: 'VIEW_CSS_DEMO',
    roles: []
  },
  {
    enabled: true,
    label: 'Synchronisierung',
    icon: 'link',
    link: path.cssPrefix + '/' + path.cssSynchronizationOverview,
    permission: 'VIEW_CSS_DEMO',
    roles: []
  },
  {
    enabled: true,
    label: 'Benutzerdetails',
    icon: 'person_search',
    link: path.cssPrefix + '/' + path.cssUserDetailsList,
    permission: 'VIEW_CSS_DEMO',
    roles: []
  },
  {
    enabled: true,
    label: 'Prozess-Konfiguration',
    icon: 'rebase',
    link: path.cssPrefix + '/' + path.cssProcessConfiguration,
    permission: 'VIEW_CSS_DEMO',
    roles: []
  },
  {
    enabled: true,
    label: 'Template-Verwaltung',
    icon: 'description',
    link: path.templateManagementPrefix + '/' + path.templateList,
    roles: ['ROLE_SUPERADMIN'],
    permission: 'VIEW_CSS_DEMO'
  },
  {
    enabled: true,
    label: 'Backend - Wertelisten',
    icon: 'settings',
    link: '/css/tenant-configuration',
    permission: 'VIEW_CSS_DEMO',
    roles: ['ROLE_SUPERADMIN'],
    children: [
      {
        label: 'Rechtsformen',
        link: '/css/tenant-configuration/legal-forms',
        permission: 'VIEW_CSS_DEMO',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        label: 'Akademische Titel',
        link: '/css/tenant-configuration/academic-titles',
        permission: 'VIEW_CSS_DEMO',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        label: 'Kontakt-Gründe',
        link: '/css/tenant-configuration/contact-reasons',
        permission: 'VIEW_CSS_DEMO',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        label: 'Buchungskreise',
        link: '/css/tenant-configuration/booking-circles',
        permission: 'VIEW_CSS_DEMO',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        label: 'Nummernkreise',
        link: '/css/tenant-configuration/number-ranges',
        permission: 'VIEW_CSS_DEMO',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        label: 'Anreden',
        link: '/css/tenant-configuration/salutations',
        permission: 'VIEW_CSS_DEMO',
        roles: ['ROLE_SUPERADMIN']
      },
      {
        label: 'Texte',
        link: '/css/tenant-configuration/texts',
        permission: 'VIEW_CSS_DEMO',
        roles: ['ROLE_SUPERADMIN']
      }
    ]
  },
  {
    label: 'Hilfe / Sonstiges',
    isTitle: true,
    roles: []
  },
  {
    enabled: true,
    label: 'Links',
    icon: 'gavel',
    link: 'routes',
    roles: ['ROLE_SUPERADMIN', 'ROLE_EDITOR_BASE']
  },
  {
    enabled: true,
    label: 'Impressum',
    icon: 'gavel',
    link: path.tmPrefix + '/' + path.termsConditions,
    permission: 'VIEW_IMPRINT',
    roles: ['ROLE_SUPERADMIN', 'ROLE_EDITOR', 'ROLE_USER', 'ROLE_ADMIN_INSTALLATEUR', 'ROLE_INSTALLATEUR']
  },
  {
    enabled: true,
    label: 'Datenschutz',
    icon: 'security',
    link: path.tmPrefix + '/' + path.privacyPolicy,
    permission: 'VIEW_DATAPOLICY',
    roles: [
      'ROLE_SUPERADMIN',
      'ROLE_ADMIN',
      'ROLE_EDITOR',
      'ROLE_USER',
      'ROLE_ADMIN_INSTALLATEUR',
      'ROLE_INSTALLATEUR'
    ]
  }
];
